<template>
  <section class="ncrm-privacy-evidence-doi" :aria-label="$t(`${copyKey}.title`)">
    <div class="text-caption text-medium-emphasis mb-2">{{ $t(`${copyKey}.title`) }}</div>
    <div v-if="!doi.sends.length" class="text-body-2 text-medium-emphasis">{{ $t(`${copyKey}.noSends`) }}</div>
    <ul v-else class="ncrm-privacy-evidence-doi__sends">
      <li v-for="send in doi.sends" :key="send.attempt_no" class="d-flex flex-wrap align-center ga-2">
        <v-chip :color="STATUS[send.status]?.color || 'neutral'"
          :prepend-icon="STATUS[send.status]?.icon || 'mdi-email-outline'">
          {{ $t(`${copyKey}.statuses.${send.status}`) }}
        </v-chip>
        <span class="text-body-2 text-no-wrap">{{ formatDateTime(send.created_at) }}</span>
        <span v-if="send.status === 'rejected'" class="text-caption text-medium-emphasis">{{ reasonLabel(send.reason_code) }}</span>
      </li>
    </ul>
    <div class="mt-3 d-flex align-center ga-2 text-body-2">
      <v-icon size="18" :color="doi.confirmed_at ? 'success' : 'neutral'">
        {{ doi.confirmed_at ? "mdi-check-circle-outline" : "mdi-timer-sand" }}
      </v-icon>
      {{ doi.confirmed_at ? $t(`${copyKey}.confirmedAt`, { at: formatDateTime(doi.confirmed_at) }) : $t(`${copyKey}.notConfirmed`) }}
    </div>
    <v-btn v-if="smtpLink" class="mt-2" variant="text" size="small" prepend-icon="mdi-email-edit-outline" :to="smtpLink">
      {{ $t(`${copyKey}.configureSmtp`) }}
    </v-btn>
  </section>
</template>

<script>
import { canAccessCompanySmtpWorkspace } from "@/Utile/ncrmMitpSync.mjs";
import { formatRegistryDateTime } from "./privacyWorkspaceContracts.mjs";

// GDPR S6 — starea emailului de confirmare DOI în detaliul dovezii unei capturi „în așteptare”:
// fiecare trimitere (rezultatul serverului SMTP și momentul) și momentul confirmării. Datele vin
// numai pe ruta de manager; fără adresă, text sau token.
const STATUS = Object.freeze({
  prepared: { color: "info", icon: "mdi-email-fast-outline" },
  accepted: { color: "success", icon: "mdi-email-check-outline" },
  rejected: { color: "error", icon: "mdi-email-remove-outline" },
  uncertain: { color: "warning", icon: "mdi-email-alert-outline" },
});
const KNOWN_REASONS = Object.freeze([
  "delivery_unavailable", "sender_config_invalid", "smtp_auth_failed", "smtp_connection_failed",
  "smtp_rejected_permanent", "smtp_rejected_temporary", "recipient_rejected", "recipient_unroutable", "render_failed",
]);
// Refuzuri care se repară din configurarea SMTP a companiei (link contextual, `docs/design.md`).
const SMTP_REASONS = Object.freeze(["delivery_unavailable", "sender_config_invalid", "smtp_auth_failed", "smtp_connection_failed"]);

export default {
  name: "NcrmPrivacyEvidenceDoiStatus",
  props: {
    doi: { type: Object, required: true },
  },
  data: () => ({ STATUS }),
  computed: {
    copyKey() { return "ncrm.contacts.dataProtection.workspace.registry.evidenceDetail.doi"; },
    smtpLink() {
      const needsSmtp = this.doi.sends.some((send) => send.status === "rejected" && SMTP_REASONS.includes(send.reason_code));
      return needsSmtp && canAccessCompanySmtpWorkspace() ? { path: "/ncrm/data-integrations", query: { tab: "smtp" } } : null;
    },
  },
  methods: {
    formatDateTime: formatRegistryDateTime,
    reasonLabel(code) {
      return this.$t(`${this.copyKey}.reasons.${KNOWN_REASONS.includes(code) ? code : "other"}`);
    },
  },
};
</script>

<style scoped>
.ncrm-privacy-evidence-doi__sends { list-style: none; margin: 0; padding: 0; display: grid; gap: 8px; }
</style>
